<script lang="ts" setup>
import Calendar from '@/assets/svg/conversations/Calendar.svg?component';
import InterviewSchedulingModal from './InterviewSchedulingModal.vue';
import { ref } from 'vue';

const props = withDefaults(
  defineProps<{
    variant: 'default' | 'compact';
    shortLabel?: boolean;
    disabled?: boolean;
  }>(),
  {
    shortLabel: false,
  },
);

const isOpen = ref(false);
const handleClick = () => {
  if (props.disabled) return;
  isOpen.value = true;
};
</script>

<template>
  <span class="flex items-center">
    <v-btn
      data-test="interview-scheduling-trigger"
      :ripple="false"
      :disabled="disabled"
      class="modal-button-primary flex"
      :class="{ compact: variant === 'compact' }"
      :density="variant === 'compact' ? 'compact' : 'default'"
      @click="handleClick"
    >
      <Calendar class="mr-2 h-4 w-4" />
      <span class="whitespace-nowrap text-xs leading-tight">{{
        shortLabel ? 'Interview' : 'Schedule interview'
      }}</span>
    </v-btn>
    <InterviewSchedulingModal v-model:open="isOpen" />
  </span>
</template>

<style scoped>
.modal-button-primary {
  @apply px-1 shadow-none;
  &.v-btn--density-compact {
    @apply !h-[28px] !px-2;
  }
}
</style>
